(() => {
  const STORAGE_KEY =
    'recentlyViewedProducts';

  const CARD_TEMPLATE =
    'recently-viewed';


  /* =========================================
     HELPERS
  ========================================= */

  function normalizeValue(value = '') {
    return String(value)
      .normalize('NFC')
      .toLocaleLowerCase('es-MX')
      .trim()
      .replace(/\s+/g, ' ');
  }


  function getItemKey(
    handle,
    color = ''
  ) {
    return `${handle}::${normalizeValue(color)}`;
  }


  function escapeSelector(value = '') {
    if (
      window.CSS &&
      typeof window.CSS.escape === 'function'
    ) {
      return window.CSS.escape(value);
    }

    return String(value).replace(
      /["\\]/g,
      '\\$&'
    );
  }


  /* =========================================
     STORAGE
  ========================================= */

  function getRecentlyViewed() {
    try {
      const stored =
        JSON.parse(
          sessionStorage.getItem(
            STORAGE_KEY
          )
        );

      if (!Array.isArray(stored)) {
        return [];
      }

      return stored.filter(
        item =>
          item &&
          typeof item === 'object' &&
          item.handle
      );

    } catch (error) {
      console.error(
        'Could not read recently viewed products:',
        error
      );

      return [];
    }
  }


  function saveRecentlyViewed(items) {
    try {
      sessionStorage.setItem(
        STORAGE_KEY,
        JSON.stringify(items)
      );

    } catch (error) {
      console.error(
        'Could not save recently viewed products:',
        error
      );
    }
  }

  function getCurrentProductData() {
    const element =
      document.querySelector(
        '[data-recently-viewed-product]'
      );

    if (!element) {
      return null;
    }

    const handle =
      element.dataset
        .recentlyViewedHandle;

    if (!handle) {
      return null;
    }

    return {
      handle,
      color: getSelectedColor()
    };
  }


  function getSelectedColor() {
    const checkedColor =
      document.querySelector(
        'input[data-option-name="Color"]:checked'
      );

    if (checkedColor) {
      return checkedColor.value || '';
    }


    const selectedColor =
      document.querySelector(
        'select[data-option-name="Color"] option:checked'
      );

    if (selectedColor) {
      return selectedColor.value || '';
    }


    const colorOption =
      document.querySelector(
        'option[data-option-name="Color"]:checked'
      );

    if (colorOption) {
      return colorOption.value || '';
    }

    return '';
  }

  function recordProduct(
    handle,
    color = ''
  ) {
    if (!handle) {
      return;
    }

    const newItem = {
      handle,
      color
    };

    const newKey =
      getItemKey(
        handle,
        color
      );

    let items =
      getRecentlyViewed();

    items =
      items.filter(
        item =>
          getItemKey(
            item.handle,
            item.color
          ) !== newKey
      );

    items.unshift(
      newItem
    );

    saveRecentlyViewed(
      items
    );


    document.dispatchEvent(
      new CustomEvent(
        'recently-viewed:updated',
        {
          detail: {
            items
          }
        }
      )
    );
  }


  function recordCurrentProduct() {
    const product =
      getCurrentProductData();

    if (!product) {
      return;
    }

    recordProduct(
      product.handle,
      product.color
    );
  }

  function handleColorChange(event) {
    const input =
      event.target.closest(
        '[data-option-name="Color"]'
      );

    if (!input) {
      return;
    }


    const productElement =
      document.querySelector(
        '[data-recently-viewed-product]'
      );

    if (!productElement) {
      return;
    }


    const handle =
      productElement.dataset
        .recentlyViewedHandle;

    if (!handle) {
      return;
    }


    requestAnimationFrame(
      () => {
        const color =
          getSelectedColor();

        recordProduct(
          handle,
          color
        );
      }
    );
  }

  function getMediaColorFromAlt(
    alt = ''
  ) {
    const beforeType =
      String(alt)
        .split(' | ')[0]
        .trim();


    const parts =
      beforeType.split(' - ');


    if (parts.length < 2) {
      return '';
    }


    return parts
      .pop()
      .trim();
  }

  function filterCardMediaByColor(
    card,
    color
  ) {
    if (
      !card ||
      !color
    ) {
      return;
    }


    const normalizedColor =
      normalizeValue(color);


    const slider =
      card.querySelector(
        '[data-card-media-slider]'
      );


    if (!slider) {
      return;
    }


    const slides =
      Array.from(
        slider.querySelectorAll(
          '[data-card-media-slide]'
        )
      );


    slides.forEach(
      slide => {
        const image =
          slide.querySelector('img');


        if (!image) {
          slide.remove();

          return;
        }


        const mediaColor =
          getMediaColorFromAlt(
            image.alt
          );


        const matches =
          normalizeValue(
            mediaColor
          ) === normalizedColor;


        if (!matches) {
          slide.remove();
        }
      }
    );


    const remainingSlides =
      slider.querySelectorAll(
        '[data-card-media-slide]'
      );


    const previousButton =
      slider.querySelector(
        '[data-card-media-prev]'
      );


    const nextButton =
      slider.querySelector(
        '[data-card-media-next]'
      );

    if (
      remainingSlides.length <= 1
    ) {
      if (previousButton) {
        previousButton.hidden =
          true;
      }

      if (nextButton) {
        nextButton.hidden =
          true;
      }
    }


    if (
      typeof window
        .initializeCardMediaSliders ===
      'function'
    ) {
      window
        .initializeCardMediaSliders(
          card
        );
    }
  }

  function configureCard(
    card,
    item,
    index = 0
  ) {
    if (!card) {
      return;
    }


    card.dataset
      .recentlyViewedHandle =
        item.handle;


    card.dataset
      .recentlyViewedColor =
        item.color || '';


    card.dataset
      .recentlyViewedKey =
        getItemKey(
          item.handle,
          item.color
        );

    card
      .querySelectorAll(
        'a[href]'
      )
      .forEach(link => {
        const href =
          link.getAttribute(
            'href'
          );

        if (
          !href ||
          !href.includes(
            `/products/${item.handle}`
          )
        ) {
          return;
        }


        try {
          const url =
            new URL(
              href,
              window.location.origin
            );


          if (item.color) {
            url.searchParams.set(
              'color',
              item.color
            );
          }


          link.setAttribute(
            'href',
            `${url.pathname}${url.search}${url.hash}`
          );

        } catch (error) {
        }
      });

    const wishlistButton =
      card.querySelector(
        '[data-wishlist-button]'
      );


    if (wishlistButton) {
      wishlistButton.dataset
        .wishlistHandle =
          item.handle;


      wishlistButton.dataset
        .wishlistColor =
          item.color || '';

      if (
        typeof window
          .updateWishlistButtons ===
        'function'
      ) {
        window
          .updateWishlistButtons();
      }
    }

    filterCardMediaByColor(
      card,
      item.color
    );

    const suffix =
      `-rv-${index}-${normalizeValue(
        item.color
      )
        .replace(
          /[^a-z0-9]+/g,
          '-'
        )
        .replace(
          /^-+|-+$/g,
          ''
        )}`;


    uniquifyCardIds(
      card,
      suffix
    );
  }

  function uniquifyCardIds(
    card,
    suffix
  ) {
    const idMap =
      new Map();


    card
      .querySelectorAll('[id]')
      .forEach(element => {
        const oldId =
          element.id;

        if (!oldId) {
          return;
        }

        const newId =
          `${oldId}${suffix}`;

        idMap.set(
          oldId,
          newId
        );

        element.id =
          newId;
      });


    if (!idMap.size) {
      return;
    }


    const attributes = [
      'for',
      'aria-labelledby',
      'aria-describedby',
      'aria-controls',
      'aria-owns',
      'aria-activedescendant'
    ];

    card
      .querySelectorAll('*')
      .forEach(element => {
        attributes.forEach(
          attribute => {
            const value =
              element.getAttribute(
                attribute
              );

            if (!value) {
              return;
            }

            const updated =
              value
                .split(/\s+/)
                .map(token =>
                  idMap.get(token) ||
                  token
                )
                .join(' ');

            if (updated !== value) {
              element.setAttribute(
                attribute,
                updated
              );
            }
          }
        );

        const modal =
          element.getAttribute(
            'data-modal'
          );

        if (
          modal &&
          modal.startsWith('#')
        ) {
          const oldId =
            modal.slice(1);

          if (
            idMap.has(oldId)
          ) {
            element.setAttribute(
              'data-modal',
              `#${idMap.get(oldId)}`
            );
          }
        }
      });
  }

  async function fetchCard(
  item,
  index = 0
) {
  const url =
    `${window.Shopify.routes.root}products/${encodeURIComponent(
      item.handle
    )}?view=recently-viewed`;


  const response =
    await fetch(
      url,
      {
        credentials: 'same-origin'
      }
    );


  if (!response.ok) {
    throw new Error(
      `Could not load recently viewed product: ${item.handle}`
    );
  }


  const html =
    await response.text();


  const parsedDocument =
    new DOMParser()
      .parseFromString(
        html,
        'text/html'
      );


  const responseWrapper =
    parsedDocument.querySelector(
      '[data-recently-viewed-card-response]'
    );


  if (!responseWrapper) {
    console.error(
      'Recently Viewed response:',
      html
    );

    throw new Error(
      `Recently viewed card markup missing for: ${item.handle}`
    );
  }

  const productComponent =
    responseWrapper.querySelector(
      ':scope > .product-grid-item'
    );


  if (!productComponent) {
    throw new Error(
      `product-component missing for: ${item.handle}`
    );
  }

  const card =
    document.importNode(
      productComponent,
      true
    );


  configureCard(
    card,
    item,
    index
  );


  return card;
}

  async function renderContainer(
    container
  ) {
    if (!container) {
      return;
    }

    const list =
      container.querySelector(
        '[data-recently-viewed-list]'
      );

    if (!list) {
      return;
    }

    const renderId =
      String(
        (Number(container.dataset.recentlyViewedRenderId) || 0) + 1
      );

    container.dataset.recentlyViewedRenderId =
      renderId;

    const items =
      getRecentlyViewed();

    const excludeCurrent =
      container.hasAttribute(
        'data-exclude-current-product'
      );

    const currentProduct =
      getCurrentProductData();

    let displayItems =
      [...items];

    if (
      excludeCurrent &&
      currentProduct
    ) {
      const currentKey =
        getItemKey(
          currentProduct.handle,
          currentProduct.color
        );

      displayItems =
        displayItems.filter(
          item =>
            getItemKey(
              item.handle,
              item.color
            ) !== currentKey
        );
    }

    const limit =
      parseInt(
        container.dataset.limit,
        10
      );

    if (
      Number.isFinite(limit) &&
      limit > 0
    ) {
      displayItems =
        displayItems.slice(
          0,
          limit
        );
    }

    list.innerHTML = '';

    if (
      !displayItems.length
    ) {
      container.hidden =
        true;

      return;
    }

    container.hidden =
      false;

    container.setAttribute(
      'aria-busy',
      'true'
    );

    const cards =
      await Promise.all(
        displayItems.map(
          (item, index) =>
            fetchCard(
              item,
              index
            ).catch(error => {
              console.error(
                error
              );

              return null;
            })
        )
      );

      if (
        container.dataset.recentlyViewedRenderId !==
        renderId
      ) {
        return;
      }

    cards.forEach(card => {
      if (card) {
        list.appendChild(
          card
        );
      }
    });

    if (!list.children.length) {
      container.hidden =
        true;
    }

    container.removeAttribute(
      'aria-busy'
    );

    if (
      typeof window
        .initializeCardMediaSliders ===
      'function'
    ) {
      window
        .initializeCardMediaSliders(
          list
        );
    }
  }

  async function renderAll() {
    const containers =
      document.querySelectorAll(
        '[data-recently-viewed-container]'
      );

    await Promise.all(
      Array.from(containers)
        .map(container =>
          renderContainer(
            container
          )
        )
    );
  }

  window.RecentlyViewed = {
    get:
      getRecentlyViewed,
    add:
      recordProduct,
    render:
      renderAll,
    renderContainer,
    getSelectedColor,
    getItemKey,
    normalizeValue
  };

  document.addEventListener(
    'recently-viewed:updated',
    () => {
      renderAll();
    }
  );

  document.addEventListener(
    'change',
    handleColorChange
  );

  document.addEventListener(
    'shopify:section:load',
    event => {
      const container =
        event.target.matches?.(
          '[data-recently-viewed-container]'
        )
          ? event.target
          : event.target.querySelector?.(
              '[data-recently-viewed-container]'
            );

      if (container) {
        renderContainer(
          container
        );
      }
    }
  );

  function init() {
    const currentProduct =
      getCurrentProductData();

    if (currentProduct) {
      recordProduct(
        currentProduct.handle,
        currentProduct.color
      );

      return;
    }
    
    renderAll();
  }

  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      init
    );

  } else {
    init();
  }
})();